import { Typography } from "@material-ui/core";
import { IAuditLogEntry } from "../../../../types";

export const FieldAuditDelete = ({ oldData }: IAuditLogEntry) => {
  return <Typography>Deleted the Field "{oldData.name}"</Typography>;
};

export default FieldAuditDelete;
